var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import querystring from 'query-string';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
var AuthService = /** @class */ (function () {
    function AuthService(http, router) {
        this.router = router;
        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'text/plain;charset=UTF-8'
        };
        this.headers2 = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
        this.notifyOptions = {
            'width': 'auto',
            'minWidth': '350px',
            'displayTime': 6000,
            'contentTemplate': 'content'
        };
        this.http = http;
    }
    AuthService.prototype.signIn = function (username, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.post(environment.api + "/token", querystring.stringify({
                'grant_type': 'password',
                'username': username,
                'password': password
            }), __assign({}, _this.headers))
                .toPromise()
                .then(function (token) {
                _this.setToken(token);
                return resolve();
            })
                .catch(function (error) {
                return reject(error);
            });
        });
    };
    AuthService.prototype.signOut = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.http.post(environment.api + "/api/user/logout", {}, { headers: __assign({}, _this.headers2, { Authorization: "Bearer " + _this.getToken() }) })
                .toPromise()
                .then(function () {
                _this.removeToken();
                return resolve();
            })
                .catch(function (error) {
                _this.removeToken();
                return resolve();
            });
        });
    };
    AuthService.prototype.setToken = function (token) {
        localStorage.setItem('token', token['access_token']);
        localStorage.setItem('tokenExpire', token['.expires']);
        localStorage.setItem('userName', token['userName']);
        localStorage.setItem('userID', token['userID']);
        localStorage.setItem('webuserID', token['webuserID']);
    };
    AuthService.prototype.getToken = function () {
        var token = localStorage.getItem('token');
        var expire = localStorage.getItem('tokenExpire');
        if (!token && !expire) {
            return null;
        }
        var now = new Date().getTime();
        var exp = new Date(expire).getTime();
        if (now >= exp) {
            this.removeToken();
            return null;
        }
        console.log('token', localStorage.getItem('token'));
        return localStorage.getItem('token');
    };
    AuthService.prototype.removeToken = function () {
        localStorage.removeItem('token');
        localStorage.removeItem('tokenExpire');
        localStorage.removeItem('userName');
        localStorage.removeItem('userID');
        localStorage.removeItem('webuserID');
    };
    AuthService.prototype.checkLoginFromResponse = function (response) {
        if (response.isLoggedIn === 0) {
            this.notifyOptions.message = 'Youv\'e been logged out, please re-login';
            notify(this.notifyOptions, 'info');
            this.router.navigate(['/']);
            return;
        }
    };
    return AuthService;
}());
export { AuthService };
